/* eslint-disable @typescript-eslint/no-unused-vars */
//
// REMOVE THIS DECLARATION, IT'S FOR VSCODE HIGHLIGNTING BLOCK
//
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PaymentPlan } from '@/types/types'
import { Plans } from '@/components/PaywallUI/Plans'
import { trackInitCheckout, trackPurchase } from '@/helpers/facebookPixelEvents'
import Timer from '@/components/PaywallUI/Timer'
import { PopupStatus } from '@/components/Checkout/PopupStatus'
import { setSuccessPayment } from '@/helpers/setSuccessPayment'
import WhatYouGetPaywall from '@/components/PaywallUI/WhatYouGetPaywall'
import MoneyBackGuarantee from '@/components/PaywallUI/MoneyBackGuarantee'
import LearnMore from '@/components/PaywallUI/LearnMore'
import { PolicyAddress } from '@/components/policyAddress'
import { PaymentForm } from '@/components/Checkout/SolidGate/PaymentForm'
import { checkUserSubscription } from '@/helpers/appHelpers'
import { generateEmail } from '@/helpers/generateEmail'

interface PaywallProps {
  paywallFile: string
}

export default function TestPaymentFormPage(props: PaywallProps) {
  const [paywallPlans, setPlans] = useState<PaymentPlan[]>([])
  const [activePlan, setActivePlan] = useState(0)
  const [userHasSubscription, setUserHasSubscription] = useState(false)
  const [paywallLoading, setPaywallLoading] = useState(true)
  // const { theme } = useTheme()
  const email = generateEmail()
  const isWhitePage = localStorage.getItem('isWhitePage')
  // const customer: Customer = { name: '', email: email ?? 'test@gmail.com' }
  const navigate = useNavigate()
  const [successPaymentStatus, setSuccessPaymentStatus] = useState(false)

  const handlePlan = (index: number) => {
    setActivePlan(index)
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await import(`../../../data/${props.paywallFile}`)
        setPlans(response?.plans)
      } catch (error) {
        console.error('Error fetching paywall data:', error)
      }
    }
    fetchData()
    trackInitCheckout()
    setPaywallLoading(true)
    checkUserSubscription(email ?? '').then((res) => {
      setUserHasSubscription(res.user && res.user.subscriptions.length > 0)
    })
  }, [])

  // const checkUserSubscription = (terminal: boolean) => {
  //   checkExistSubscription({ email: email as string, name: '' }, terminal).then((res) => {
  //     if (!res.error && res.existSubscription > 0) {
  //       setUserHasSubscription(res.existSubscription)
  //     }
  //   })
  // }

  useEffect(() => {
    if (successPaymentStatus) {
      trackPurchase()
    }
  }, [successPaymentStatus])

  useEffect(() => {
    localStorage.setItem('activePlan', JSON.stringify(paywallPlans[activePlan]))
  }, [paywallPlans, activePlan])

  useEffect(() => {
    const scrollTimeout = setTimeout(() => {
      window.scrollTo(0, 0)
    }, 0)
    return () => clearTimeout(scrollTimeout)
  }, [paywallPlans])

  return (
    <>
      {paywallPlans.length > 1 && (
        <>
          <h1 className="mt-6 font-bold text-XL text-center">Safe checkout</h1>
          <Timer />
          <Plans activePlan={activePlan} handlePlan={handlePlan} plans={paywallPlans} />
          <WhatYouGetPaywall />
          <PaymentForm
            plan={{
              ...paywallPlans[activePlan],
              ...{ solidGateProductID: 'e0a9a30b-facd-44c5-898e-ce3a57a9314f' },
            }}
            email={email ?? ''}
            handleLoading={(val) => {
              if (paywallLoading) {
                setPaywallLoading(val)
                window.scrollTo(0, 0)
              }
            }}
            onSuccess={setSuccessPaymentStatus}
          />
          {/* <ApplePayForm */}
          {/*  onSuccess={setSuccessPaymentStatus} */}
          {/*  plan={paywallPlans[activePlan]} */}
          {/*  handleLoading={setPaywallLoading} */}
          {/*  customer={customer} */}
          {/* /> */}
          {/* <CardForm */}
          {/*  onSuccess={setSuccessPaymentStatus} */}
          {/*  plan={paywallPlans[activePlan]} */}
          {/*  customer={customer} */}
          {/* /> */}
          <MoneyBackGuarantee />
          <LearnMore text={paywallPlans[activePlan].text} />
          {isWhitePage === 'true' && (
            <div className="mt-[-40px]">
              <PolicyAddress />
            </div>
          )}
          {successPaymentStatus && (
            <PopupStatus
              icon="/img/success-icon.png"
              title="Your payment was successfull!"
              message="Thank you!"
              buttonTitle="Proceed To My Plan"
              onClick={() => setSuccessPayment({ res: true }, navigate)}
            />
          )}
          {userHasSubscription && (
            <PopupStatus
              icon="/img/success-icon.png"
              title="You already have subscription"
              buttonTitle="Proceed To Download"
              onClick={() => navigate('/thank-you')}
            />
          )}
        </>
      )}
      {paywallLoading && (
        <div className="fixed top-0 left-0 w-full h-full bg-white dark:bg-black z-10 pointer-events-auto opacity-100">
          <div className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
            <svg viewBox="0 0 100 100" height="76" className="animate-spin">
              <use href="/svg/sprite.svg#spinner"></use>
            </svg>
          </div>
        </div>
      )}
    </>
  )
}
